<app-dashboarditem [title]="title">
  <div class="asklearnshare-container">
    <ngb-carousel [interval]="10000" [showNavigationArrows]="false" (slide)="onSlide($event)">
      <!--When debugging use [interval]="0" to stop Carousel scroll-->
      <!--<ng-template ngbSlide>
        <div>
          <app-tipoftheweek-container></app-tipoftheweek-container>
        </div>
      </ng-template>-->

      <ng-template ngbSlide>
        <div>
          <app-tango-Training></app-tango-Training>
        </div>
      </ng-template>
      <ng-template ngbSlide>
        <app-assessment-promo></app-assessment-promo>
      </ng-template>
      <!--<ng-template ngbSlide>
        <app-sale-advertisement></app-sale-advertisement>
      </ng-template>-->
    </ngb-carousel>
  </div>
</app-dashboarditem>
